import { Copy, DomHelpers, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { ratingColour } from 'helpers/metrics';
import { withRouter } from 'react-router-dom';
import { translateCompetency } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const CompetencyRecommendations = ({ text, comps, showPlusMinus, roundTo = 1, history, filterCompetencies }) => {
    const { user } = useSelector(state => state.user);

    const localColour = (x, i) => {
        x = !showPlusMinus ? x : i === 0 ? 5 : i === 1 ? 4 : 3;
        return ratingColour(x, 'grey');
    };

    const loaded = React.useRef(null);

    React.useEffect(() => {
        loaded.current && setTimeout(DomHelpers.matchWidth('fix-size', loaded.current), 250);
    }, [loaded.current]);

    return (
        <div ref={loaded}>
            <p>
                <Copy value={text} />
            </p>
            <ul>
                {comps
                    .map(c => translateCompetency(user.language_Code, c))
                    .map((c, i) => (
                        <li
                            key={`comps-${c.id}`}
                            data-testid="li-search-comps"
                            className="flex flex-center list-image pointer"
                            onClick={() => history.push(`/search?competency=${c.id}`)}
                            title={SystemText('Dashboard/Widgets/Recommends/Competencies/Search', c.name)}
                        >
                            <span>
                                <label
                                    className={`${showPlusMinus ? 'pr10' : 'mr10'} label label-${localColour(
                                        c.averageCurrent,
                                        i
                                    )}`}
                                >
                                    <span
                                        className="fix-size"
                                        style={{
                                            display: 'inline-block',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {showPlusMinus && <>+</>}
                                        {(!showPlusMinus ? c.averageCurrent : c.averageInitial).toFixed(roundTo)}
                                    </span>
                                </label>
                            </span>
                            <span className="ml5 flex-grow">
                                <span>{c.full_Name} </span>
                                <i className="fa fa-search ml10" />
                            </span>
                        </li>
                    ))}
            </ul>
            {filterCompetencies && (
                <div className="ml10 mt20">
                    <button
                        data-testid="button-filter-comps"
                        className="btn btn-primary btn-sm"
                        onClick={() => filterCompetencies(comps)}
                    >
                        <i className="fa fa-filter mr10" />
                        {SystemText('Dashboard/Widgets/Recommends/Competencies/Filter')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default withRouter(CompetencyRecommendations);
